<template>
  <div id="formFacility">
    <Topbar @action="fnAction"></Topbar>
    <ClipperImage
      v-if="clipper"
      :image="clipper"
      @getImage="showThumb"
    ></ClipperImage>
    <v-container class="center">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 class="item">
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-layout row wrap>
                <v-flex xs6 md6 class="item">
                  <div class="image">
                    <img
                      @click="addThumbnail('image')"
                      v-if="facility['image']"
                      :src="facility['image_preview']"
                    />
                    <div @click="addThumbnail('image')" v-else class="addthumb">
                      <div><v-icon x-large>add</v-icon></div>
                      <div class="text">
                        {{ $t("add") + " " + $t("params.image") }}
                      </div>
                    </div>
                    <input
                      type="file"
                      style="display: none"
                      ref="image"
                      accept="image/*"
                      @change="onThumbnailPicked"
                    />
                  </div>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.name' | i18n"
                    v-model="facility.name"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.name_competition' | i18n"
                    v-model="facility.name_competition"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.city' | i18n"
                    v-model="facility.city"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.state' | i18n"
                    v-model="facility.state"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.address' | i18n"
                    v-model="facility.address"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.cp' | i18n"
                    v-model="facility.cp"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-select
                    v-model="facility['country_id']"
                    :label="'params.country' | i18n"
                    :items="countries"
                    @input.native="loadAutocomplete($event, false)"
                    autocomplete
                  ></v-select>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-select
                    v-model="facility['municipal']"
                    :label="'params.municipal' | i18n"
                    :items="Object.values(si_no_nsncOptions)"
                    :item-text="item => $t(item.text)"
                    item-value="value"
                  ></v-select>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.phone' | i18n"
                    v-model="facility.phone"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.email' | i18n"
                    v-model="facility.email"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.web' | i18n"
                    v-model="facility.web"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-select
                    v-model="facility['sport']"
                    :label="'params.activities' | i18n"
                    :items="Object.values(sports)"
                    :item-text="item => $t('campus.' + item.name)"
                    item-value="id"
                  ></v-select>
                </v-flex>

                <v-flex xs6 md6 class="item" v-if="facility.sport == '1'">
                  <v-select
                    v-model="facility['ground_type']"
                    :label="'params.grass' | i18n"
                    :item-text="item => $t('params.' + item.text)"
                    :items="grassOptions"
                  ></v-select>
                </v-flex>

                <v-flex
                  xs6
                  md6
                  class="item"
                  v-else-if="
                    facility.sport != undefined && facility.sport != ''
                  "
                >
                  <v-select
                    v-model="facility['ground_type']"
                    :item-text="item => $t('params.' + item.text)"
                    :label="'params.pavement' | i18n"
                    :items="pavementOptions"
                  ></v-select>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.spectators' | i18n"
                    v-model="facility.spectators"
                    type="number"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.changing_rooms' | i18n"
                    v-model="facility.changing_rooms"
                    type="number"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.megafonia"
                    :label="'params.megafonia' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.wifi"
                    :label="'params.wifi' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.parking"
                    :label="'params.parking' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.infirmary"
                    :label="'params.infirmary' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.grada"
                    :label="'params.grada' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-select
                    v-model="facility['grada_type']"
                    :label="'params.grada_type' | i18n"
                    :item-text="item => $t('params.' + item.text)"
                    :items="grada_typeOptions"
                  ></v-select>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.illumination"
                    :label="'params.illumination' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.bar"
                    :label="'params.bar' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.defibrillator"
                    :label="'params.defibrillator' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.closed_perimeter"
                    :label="'params.closed_perimeter' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-switch
                    v-model="facility.warmup_zone"
                    :label="'params.warmup_zone' | i18n"
                  ></v-switch>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.latitud' | i18n"
                    v-model="facility.latitud"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.longitud' | i18n"
                    v-model="facility.longitud"
                    outline
                  ></v-text-field>
                </v-flex>

                <v-flex xs6 md6 class="item">
                  <v-text-field
                    :label="'params.meteocat' | i18n"
                    v-model="facility.meteocat"
                    placeholder='<iframe src="https://static-m.meteo.cat/giny...'
                    outline
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import i18n from "@/i18n";

import Table from "@/components/ui/Table";
import Topbar from "@/components/ui/Topbar";
import ClipperImage from "@/components/ui/ClipperImage";

import { Api } from "@/core/api.js";
const api = new Api();

export default {
  name: "FormFacility",
  components: { Table, Topbar, ClipperImage },
  props: { page: String, action: String },
  data() {
    return {
      facility: {},
      clipper: false,
      // FORM VARIABLES
      valid: true,
      dataLoaded: false,
      // FORM TYPE OPTIONS
      pavementOptions: [
        { value: "linolelum", text: "linolelum" },
        { value: "terratzo", text: "terratzo" },
        { value: "portland", text: "portland" }
      ],
      grassOptions: [
        { value: "artificial", text: "artificial" },
        { value: "natural", text: "natural" }
      ],
      grada_typeOptions: [
        { value: "covered", text: "covered" },
        { value: "uncovered", text: "uncovered" }
      ],
      si_no_nsncOptions: [
        { value: "1", text: "si" },
        { value: "2", text: "no" },
        { value: "0", text: "nsnc" }
      ]
    };
  },
  computed: {
    countries() {
      var oCountries = this.$store.getters.getCountries();
      var aResult = [];
      for (var k in oCountries) {
        aResult.push({ text: oCountries[k].name, value: oCountries[k].id });
      }

      return aResult;
    },

    sports() {
      return this.$store.getters.getSports();
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage"
  },
  created() {
    this.loadDataPage();
  },
  methods: {
    loadDataPage() {
      this.$overlay.loading();
      var self = this;

      var fullPage = self.page.replace("event_", "");
      var page = self.page.replace("event_", "").split("_")[0];
      var oParams = { ...self.$route.params };
      if (self.$store.state.event_selected) {
        oParams.event = self.$store.getters["events/getCurrentEvent"]().id;
      }

      oParams.id = self.$route.params.id;
      // EDIT
      if (typeof oParams.id !== "undefined") {
        self.$store.dispatch(page + "/load_by_id", oParams).then(function() {
          self.facility = {
            ...self.$store.getters[page + "/get_by_id"](oParams.id)
          };
          if (self.facility.image) {
            self.facility.image_preview = self.facility.image;
          }
          self.dataLoaded = true;
          self.$overlay.hide();
        });
      }
      // ADD
      else {
        this.dataLoaded = true;
        this.$overlay.hide();
      }
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "save":
          this.fnSave();
          break;
      }
    },

    fnSave() {
      if (this.$refs.form.validate()) {
        var self = this;
        var page = this.page.replace("event_", "").split("_")[0];
        var fullPage = this.page.replace("event_", "");
        var event = self.$store.getters.isEventSelected
          ? self.$store.getters["events/getCurrentEvent"]()
          : false;
        var id_event = event ? event.id : false;

        var facility = { ...this.facility };

        this.$overlay.loading();

        this.$store
          .dispatch("facilitys/upload", { data: facility, event: id_event })
          .then(function(idEntity) {
            page = event ? "event_" + page : page;
            self.$router.push({
              name: page + "_card",
              params: {
                id: idEntity,
                event: event
                  ? self.$root
                      .formatEventUrl(event.name, event.edition)
                      .replace("/event/", "")
                  : null
              }
            });
          });
      } else {
        this.$popup.alert({
          message: i18n.t("exists_error_on_form"),
          btnSuccess: i18n.t("accept")
        });
      }
    },

    loadAutocomplete(event, param) {
      this.param_autocomplete = param.param;
      clearTimeout(this.toAutoComplete);
      var self = this;
      this.toAutoComplete = setTimeout(function() {
        if (event.target.value.length > 2) {
          self.$store
            .dispatch(param.action, event.target.value)
            .then(function() {
              var aResults = self.$store.getters[param.getter]();
              var aResult = [];
              for (var k in aResults) {
                var result = aResults[k];
                aResult.push({ text: result.name, value: result.id });
              }

              self.cAutoComplete = aResult;
            });
        }
      }, 200);
    },

    addThumbnail(param) {
      this.param_select = param;
      this.$refs[param].click();
    },
    onThumbnailPicked(e) {
      const files = e.target.files;
      var self = this;
      if (files[0] !== undefined) {
        if (files[0].type.includes("image")) {
          if (this.clipper) URL.revokeObjectURL(this.clipper);
          this.clipper = window.URL.createObjectURL(e.target.files[0]);
        } else {
          var data_copy = { ...this.facility };
          data_copy[this.param_select] = e.target.files[0];
          this.facility = data_copy;
        }
      }
    },
    showThumb(image) {
      // console.log( image );
      this.clipper = false;
      this.facility["image_preview"] = image;

      function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }

      if (image) {
        this.facility["image"] = dataURLtoFile(
          image,
          "image_" + moment().valueOf() + ".jpg"
        );
        // console.log( this.data[ this.param_select ] );
      }
    }
  },
  filters: {
    checkParam(value) {
      return value != null ? value : "";
    },

    formatType(value) {
      switch (value) {
        case null:
          return "";
          break;
        case 1:
          return "Administrador Backoffice";
          break;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#formFacility {
  width: 100%;
  display: inline-block;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 100px;

  .container {
    width: 80%;
    width: calc(100% - 350px);
    padding: 0px;

    &.center {
      margin: 0 auto;
    }

    .name {
      margin-top: 25px;
      font-size: 22px;
      border-bottom: 2px solid;
      /*cursor: pointer;*/
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      /*&::after {
                    content: "";
                    width: 20px;
                    height: 20px;
                    background: url(/img/down.svg);
                    background-repeat: no-repeat;
                    background-size: 20px;
                    background-position: center right;
                    position: absolute;
                    transition-duration: 0.2s;
                    margin-left: 10px;
                }
                
                &.hidden {
                    &::after {
                        transform: rotate(180deg);
                        transition-duration: 0.2s;
                    }
                }*/
    }

    .clear {
    }

    .role {
      padding: 0;

      .container {
        margin: 0;
        width: 100%;

        .name {
          font-size: 18px;
          color: #685f5f;
        }
      }
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }

      .item.flex {
        padding: 0 20px;

        .image {
          // width: 40%;
          float: left;
          padding: 0 40px;

          img,
          .addthumb {
            width: 150px;
            border: 1px solid #ccc;
            height: 150px;
            position: relative;
            cursor: pointer;
          }

          .addthumb div {
            width: 100%;
            display: block;
            top: 35%;
            position: absolute;
            text-align: center;
          }
          .addthumb .text {
            top: 60%;
          }
        }

        .name {
          position: relative;

          .remove {
            width: fit-content;
            float: right;
          }

          .add {
            background-image: url(/img/add_b.svg);
            background-size: 15px;
            background-repeat: no-repeat;
            background-position: left center;
            position: absolute;
            right: 0;
            top: 15px;
            padding-left: 20px;
            text-transform: none;
            font-weight: bold;
            cursor: pointer;
          }
        }

        .v-input:not(.v-input--radio-group) .v-input__slot {
          border: none;
          border-bottom: 2px solid rgba(0, 0, 0, 0.14);
          border-radius: 0;
          padding-left: 0;
        }

        .v-input__prepend-inner {
          margin-top: 25px;
        }

        .v-input.upper input {
          text-transform: uppercase;
        }
      }

      .v-menu__content {
      }
      .v-select {
        label {
          top: 0px;
          padding-left: 0;
          font-size: 18px;
          /*display: none;*/
        }
      }
    }
  }

  .person_list {
    border-bottom: 1px solid #777;

    .item {
      width: 100%;
      margin: 0 auto;
      border-bottom: 1px solid #ddd;

      &:last-of-type {
        border: none;
      }

      .row {
        width: 100%;
        height: 50px;

        .avatar {
          width: 20%;
          display: inline-block;
          float: left;
          line-height: 3;

          .v-image {
            margin: 7.5px;
            height: 35px;
            width: 35px;
          }

          .letter {
            line-height: 0px;
            background-color: blue;
            border-radius: 100%;
            text-align: center;
            color: white;
            padding: 10px 15px;
            margin: 6px;
          }
        }
        .content {
          height: 50px;
          width: 80%;
          display: inline-block;
          line-height: 50px;
          overflow: hidden;

          .options {
            float: right;
            display: inline-block;
            line-height: 3;

            .number {
              width: 60px;
              float: left;
              display: inline-block;
              line-height: 3;
            }

            .actions {
              display: inline-block;
              float: right;
              line-height: 3;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .pax {
    line-height: 50px;
    height: 50px;

    .item {
      margin: 0 auto;
      float: right !important;

      .label {
        display: inline-block;
      }

      .v-input {
        display: inline-block;
        width: 60px;
        text-align: center;

        input {
          text-align: center;
        }
      }
    }
  }
}

.empty {
  .row {
    height: 50px;
    text-align: center;
    .content {
      height: 50px;
      line-height: 50px;
      width: 100%;
      margin: 0 auto;
      float: none;
      text-align: center;
      color: #444;
    }
  }
}
</style>
